import Button from "react-bootstrap/Button";
import React from "react";
import {closeModal} from "src/utilities/utilityFunctions";

const ModalCloseButton = (props) => {
    let triggerName = props.triggerName ? props.triggerName : "showDefaultModal";
    return (
        <Button variant="secondary"
                onClick={() =>{closeModal(triggerName)}} id="modalCloseButton">
            Close
        </Button>
    )
};

export default ModalCloseButton;
